import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import SubsectionView from "./SubsectionView";

/**
 * Renders a single content section with title, text, and subsections.
 * @param {object} props
 * @param {object} props.section - Section data with number, title, text, subsections
 * @returns {React.ReactElement}
 */
function SectionBlock({ section }) {
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    const textColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <Box mb="16px">
            <Text fontSize="0.85rem" fontWeight="700" mb="4px" color={titleColor}>
                {section.number}. {section.title}
            </Text>
            {section.text && (
                <Text fontSize="0.8rem" mb="8px" whiteSpace="pre-line" color={textColor}>{section.text}</Text>
            )}
            {(section.subsections || []).map((sub, subIdx) => <SubsectionView key={subIdx} subsection={sub} />)}
        </Box>
    );
}

/**
 * Renders all content sections of a legal document in a scrollable container.
 * Shows an empty state message when there are no sections.
 * @param {object} props
 * @param {Array} props.sections - Array of section objects from the document content
 * @returns {React.ReactElement}
 */
function DetailContentSections({ sections }) {
    const labelColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <>
            <Text fontSize="0.8rem" fontWeight="600" textTransform="uppercase" letterSpacing="0.5px"
                mb="12px" color={labelColor}>
                Content ({sections.length} sections)
            </Text>
            <Box maxH="400px" overflowY="auto">
                {sections.map((section, idx) => <SectionBlock key={idx} section={section} />)}
                {sections.length === 0 && (
                    <Text fontSize="0.8rem" textAlign="center" py="16px" color={labelColor}>No content</Text>
                )}
            </Box>
        </>
    );
}

export default DetailContentSections;
